import type { FC } from 'react';
import React from 'react';
import { FlexRow, Box } from '@edreamsodigeo/prisma-design-system';

const CheckoutPageContentContainer: FC = ({ children }) => (
  <Box backgroundColor={{ _: 'neutral.0', md: 'neutral.30' }}>
    <FlexRow
      gap="0"
      width="100%"
      justifyContent="center"
      pt={{ _: '0', md: '3x_big' }}
      pb={{ _: '0', md: '1x_big' }}
    >
      {children}
    </FlexRow>
  </Box>
);

export default CheckoutPageContentContainer;
